import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMountedState } from 'react-use';
import { v4 } from 'uuid';
import { logger } from 'common/utils/helpers';
import { addToastNotification } from 'redux/actions';
import { selectUserPreferences } from 'redux/selectors';
import { deleteChartPreference, selectUserPreference } from 'redux/UserPreferences';
import ActionDialog from 'components/shared/ActionDialog/ActionDialog';

function ChartPreferenceDeleteDialog({ preferenceId, onClose, onDelete }) {
  const dispatch = useDispatch();
  const isMounted = useMountedState();
  const [deletingChart, setDeletingChart] = useState(false);
  const preference = useSelector((state) => selectUserPreference(selectUserPreferences(state), preferenceId));
  const preferenceName = preference?.name || 'this chart';

  const deleteChart = useCallback(async () => {
    if (preference?.local === true) {
      alert('Local chart cannot be deleted');
      return;
    }

    setDeletingChart(true);

    try {
      await dispatch(deleteChartPreference(preference));
      dispatch(
        addToastNotification({
          id: v4(),
          title: preference.name,
          description: 'successfully removed.'
        })
      );
      if (onDelete) {
        onDelete();
      }
      onClose();
    } catch (error) {
      logger.error(error);
    } finally {
      if (isMounted()) {
        setDeletingChart(false);
      }
    }
  }, [dispatch, isMounted, onDelete, onClose, preference]);

  return (
    <ActionDialog
      onClose={onClose}
      title="Delete Chart"
      message={
        <span>
          Are you sure you want to delete {preferenceName}? This chart will be deleted from all other chart sets that
          use it. This action cannot be undone.
        </span>
      }
      fetching={deletingChart}
      actionHandler={deleteChart}
      isGlobal={true}
    />
  );
}

export default ChartPreferenceDeleteDialog;
